// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8960d32","239":"177bd38c","732":"b13d71d4"}[chunkId] + ".chunk.js";
};